/**
 * Hook for fetching work sections (sections).
 */

import { gql, useQuery } from "@apollo/client";

export interface Section {
  id: string;
  name: string;
  code: string | null;
  procurementPackageId: string | null;
  templateWorkSectionId: string | null;
  subcontractorId: string | null;
  plannedStart: string | null;
  plannedEnd: string | null;
}

interface SectionConnection {
  items: Section[];
  totalCount: number;
  hasNextPage: boolean;
}

interface SectionsQueryResult {
  sections: SectionConnection;
}

const GET_SECTIONS = gql`
  query GetSections($limit: Int, $offset: Int) {
    sections(limit: $limit, offset: $offset) {
      items {
        id
        name
        code
        procurementPackageId
        templateWorkSectionId
        subcontractorId
        plannedStart
        plannedEnd
      }
      totalCount
      hasNextPage
    }
  }
`;

export function useSections() {
  const { data, loading, error } = useQuery<SectionsQueryResult>(
    GET_SECTIONS,
    {
      variables: { limit: 500, offset: 0 },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    sections: (data?.sections.items || []) as Section[],
    totalCount: data?.sections.totalCount || 0,
    loading,
    error,
  };
}
